// Taşeron portalı — giriş/aktivasyon SONRASI panel-vs-app kapısı (plan D3). Auth'lu kabuğun
// EN ÜSTÜNDE durur; panel-erişim probunun (`useSupplierContractorAccess`, `GET /supplier/contractor`)
// sonucuna göre ya normal portalı (`AppLayout`) ya da Personeli'nin tam-ekran indirme görünümünü
// (`AppDownloadOnly`) render eder:
//   - loading                 → tam-ekran spinner
//   - forbidden (Personeli)   → AppDownloadOnly (tüm kabuk yerine YALNIZ indirme; menü/nav YOK)
//   - granted  (Yetkili)      → AppLayout (normal portal — NAV + Outlet)
//   - unavailable (5xx/ağ)    → AppLayout (MEVCUT davranış: iç sayfalar kendi hata/retry'ını gösterir;
//                               app-download'a DÜŞMEZ — geçici servis hatası Personeli'ye benzemesin)
//
// `AppLayout` içindeki `<Outlet/>` alt rotaları taşır; forbidden'da Outlet render EDİLMEZ (dolayısıyla
// hangi yolda olursa olsun Personeli yalnız indirme ekranını görür). Probe react-query ile
// önbelleklidir (aynı anahtar) → `AppLayout`in NAV probu ile çift istek üretmez.

import { Spinner } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { AppLayout } from '../layouts/AppLayout';
import { useSupplierContractorAccess } from '../lib/supplierContractorAccess';
import { AppDownloadOnly } from './AppDownloadOnly';

export function SupplierShellGate() {
  const { t } = useTranslation();
  const access = useSupplierContractorAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bg">
        <Spinner label={t('access.loading')} />
      </div>
    );
  }

  // Panel yetkisi YOK (Personeli) → tüm kabuk yerine yalnız indirme ekranı (D3).
  if (access.status === 'forbidden') {
    return <AppDownloadOnly />;
  }

  // granted VEYA unavailable → normal kabuk (unavailable'da iç sayfalar kendi durumunu gösterir).
  return <AppLayout />;
}
